import jsPDF from 'jspdf';
import { htFileBase } from './buildHtParams';
import { drawHtPart1Pdf } from './drawHtPart1Pdf';

const MARGIN = 10;

export function htPdfFileName(params) {
  return `${htFileBase(params)}.pdf`;
}

export function buildHtPdfDoc(params) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageW = doc.internal.pageSize.getWidth();
  const contentW = pageW - MARGIN * 2;

  drawHtPart1Pdf(doc, params, MARGIN, contentW);

  return doc;
}

export function generateHtPdf(params) {
  const doc = buildHtPdfDoc(params);
  doc.save(htPdfFileName(params));
}
